import {
  DialogBody,
  DialogFooter,
  DialogFooterActions,
} from '_core/dialogs/dialog';
import { FinalForm } from '_core/final-form/finalForm';
import { DialogForm } from '_core/forms/dialogForm';
import { FormErrors } from '_core/forms/formErrors';
import { DateInputInFormGroupForFinalForm } from '_core/inputs/dateInput';
import { FormGroupForFinalForm } from '_core/inputs/formGroup';
import { InputMultipleForFinalForm } from '_core/inputs/inputMultiple';
import { Button, Intent } from '@blueprintjs/core';
import * as React from 'react';

export interface IRentWagonsPurchaseCloseDialogFormValues {
  actFile: string | null;
  endDate: Date;
  wagons: string;
}

interface IProps {
  initialValues: IRentWagonsPurchaseCloseDialogFormValues;
  isOpen: boolean;
  onClose: () => void;
  onClosed: () => void;
  onSubmit: (values: IRentWagonsPurchaseCloseDialogFormValues) => void;
}

export function RentWagonsPurchaseCloseDialogForm({
  initialValues,
  isOpen,
  onClose,
  onClosed,
  onSubmit,
}: IProps) {
  return (
    <FinalForm initialValues={initialValues} onSubmit={onSubmit}>
      {({ error, handleSubmit, submitError, submitting }) => (
        <DialogForm
          isOpen={isOpen}
          isSubmitting={submitting}
          title="Вывести вагоны из аренды"
          onClose={onClose}
          onClosed={onClosed}
          onSubmit={handleSubmit}
        >
          <DialogBody>
            <FormErrors error={error || submitError} />

            <DateInputInFormGroupForFinalForm
              id="endDate"
              label="Дата вывода из аренды"
              name="endDate"
            />

            <FormGroupForFinalForm
              label="Вагоны"
              labelFor="wagons"
              name="wagons"
            >
              <InputMultipleForFinalForm id="wagons" name="wagons" />
            </FormGroupForFinalForm>
          </DialogBody>

          <DialogFooter>
            <DialogFooterActions>
              <Button disabled={submitting} text="Отмена" onClick={onClose} />

              <Button
                disabled={submitting}
                intent={Intent.PRIMARY}
                loading={submitting}
                text="Вывести"
                type="submit"
              />
            </DialogFooterActions>
          </DialogFooter>
        </DialogForm>
      )}
    </FinalForm>
  );
}
